<template>
  <div id="app-index">
    <info-head></info-head>
    <nav-bar></nav-bar>
    <info-nav></info-nav>
    <info-foot></info-foot>
  </div>
</template>
<script>
import animate from 'animate.css'
import infoHead from "../Public/head";
import navBar from "../Public/nav";
import infoNav from "./info_nav";
import infoFoot from "../Public/foot";    

export default {
  components:{
    infoHead,
    navBar,
    infoFoot,
    infoNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Info/info_index.vue